{
    "confirm": {
        "confirmToDeleteMediaAndRemoveFromProjects": "حذف وإزالة من المشروع | حذف وإزالة من المشاريع",
        "unsavedChanges": "تغييرات غير محفوظة!",
        "areYouSureYouWantToRemovePage": "حذف \"{pageName}\".",
        "deleteStyle": "حذف النمط?",
        "deleteMedia": "حذف الوسائط?",
        "deleteMediaImplications": "حذف وإزالة من المشاريع؟",
        "deletePlayer": "حذف المشغل?",
        "deletePlayerImplications": "سيؤدي هذا الإجراء إلى إزالة المشغل من حساب \"ARYA\"الخاص بك وحذف جميع الإعدادات المتعلقة بهذا المشغل بما في ذلك جميع الجداول.",
        "permanentlyDeleteTheUserAccount": "حذف الحساب",
        "removeTemplate": "إزالة القالب",
        "removeTemplateDesc": "هل تريد إزالة هذا القالب من هذا النمط؟",
        "removeTheMediaFromTheSchedule": "حذف من الجدول",
        "mediaNamesIsInUploadStateAndWillPermanentlyDelete": "حذف الوسائط",
        "mediaUsedInProject": "الوسائط المستخدمة في المشروع | الوسائط المستخدمة في المشاريع",
        "confirmPassword": "تأكيد كلمة المرور",
        "changeEmail": "تغيير البريد الإلكتروني",
        "deleteOrder": "حذف الطلب",
        "deleteTag": "حذف العلامة؟",
        "deletePopId": "حذف معرف PoP؟",
        "deleteUser": "حذف المستخدم؟",
        "deleteAccount": "حذف الحساب؟",
        "leaveAccount": "مغادرة الحساب؟",
        "deleteCanvasResolution": "حذف دقة اللوحة؟",
        "downloadLicense": "تنزيل الترخيص؟",
        "cancelOrder": "إلغاء الطلب؟",
        "removeAccessFromArya": "إزالة الوصول من ARYA؟",
        "deleteTemplate": "حذف القالب؟"
    },
    "signinup": {
        "new": "جديد في {productNameShort}؟",
        "newUser": "مستخدم جديد"
    },
    "label": {
        "aryaAccountID": "معرف حساب ARYA",
        "accountId": "معرف الحساب",
        "admin": "مشرف",
        "addPlayer": "إضافة لاعب",
        "assignCodeHasAlreadyBeenAssignedInAnotherAccountErrorMessage": "لقد تم بالفعل تعيين الرمز {code}.",
        "assignCodeHasAlreadyBeenAssignedErrorMessage": "تم تعيين الرمز {code} بالفعل.",
        "account": "الحساب | الحسابات",
        "accountInfo": "معلومات الحساب",
        "accountInformation": "معلومات الحساب",
        "accountName": "إسم الحساب",
        "accountPlan": "خطة الحساب",
        "accountCorrespondent": "مراسل الحسابات",
        "accountIsDeleted": "تم حذف الحساب",
        "activate": "تفعيل",
        "address": "عنوان",
        "alert": "انذار | تنبيهات",
        "amount": "كمية",
        "apply": "يتقدم",
        "assign": "تعيين | يعين",
        "audio": "صوتي",
        "auto": "تلقاءي",
        "basic": "أساسي",
        "bannerText1": "الصيانة المجدولة",
        "bannerText2": "سنخضع لأعمال صيانة مجدولة في {date} في {time} لنحو {approximateHours} ساعة. نعتذر عن أي إزعاج حدث خلال هذه الفترة.",
        "bannerText3": "أثناء الصيانة ، لن يكون {productName} متاحًا لتعديلات المحتوى ، ولكن سيستمر اللاعبون في عرض المحتوى الخاص بهم.",
        "billing": "الفواتير",
        "billingDetails": "تفاصيل الفاتورة",
        "buy": "يشترى",
        "comment": "تعليق",
        "companyInformation": "معلومات الشركة",
        "contentNotSupported": "المحتوى غير مدعوم ، انقر للحصول على مزيد من المعلومات ...",
        "copy": "ينسخ | نسخ",
        "configPending": "إعدادات معلقة",
        "configError": "خطأ في الإعدادات",
        "credentials": "أوراق اعتماد",
        "credentialsNotValid": "أوراق الاعتماد غير صالحة",
        "createStyle": "خلق الاسلوب",
        "createUserExistErrorMessage": "{email} هو بالفعل عضو في هذا الحساب.",
        "createUserLimitReached": "تم الوصول إلى حد المستخدم",
        "creditCard": "بطاقة إئتمان",
        "download": "تحميل",
        "extended": "تمديد",
        "expirationDate": "تاريخ انتهاء الصلاحية",
        "expires": "تنتهي",
        "keyboardShortcuts": "اختصارات لوحة المفاتيح",
        "language": "لغة",
        "learnMore": "تعلم أكثر",
        "leaveAccount": "ترك الحساب",
        "leaveAccountWithOnlyOneUserMessage": "لا يمكنك ترك الحساب لأنك المستخدم الوحيد في الحساب.",
        "leaveAccountTheOnlyAdminInTheAccountMessage": "لا يمكنك ترك الحساب لأنك المسؤول الوحيد في الحساب.",
        "leaveAccountImplicationsCommonMessage": "سيؤدي هذا الإجراء إلى إزالتك من هذا الحساب.",
        "license": "رخصة",
        "limited": "محدود",
        "location": "موقع",
        "login": "تسجيل الدخول",
        "loginError": "حدث خطأ ما ، لا يمكننا تسجيل دخولك في الوقت الحالي ، يرجى إعادة المحاولة لاحقًا أو الاتصال بالمسؤول",
        "loginWith": "تسجيل الدخول عبر",
        "loginString2": "المحتوى على الشاشة في وقت واحد. مجانا.",
        "loginString3": "البساطة تلتقي باللافتات الرقمية.",
        "loginString4": "اطلب وقم بتفعيل مجموعات الميزات بسلاسة",
        "loginOKStringTitle2": "Smart Sync. البساطة تلتقي",
        "loginOKStringDesc1": "عدله. الجدول الزمني لها. أعطها الأولوية.",
        "loginOKStringDesc2": "الوسم. مزامنة ذكية. تنبيه إذا لزم الأمر.",
        "loginOKString4": "الخطوة التالية. الإعداد السريع للجهاز .",
        "loginOKString5": "كل ما تحتاجه هو الرقم التسلسلي للجهاز.",
        "loginOKQuotaWarnMain": "تخزين مجاني {percentage}٪ ممتلئ.",
        "loginOKQuotaWarnSub": "قم بالترقية إلى {plan} للحصول على سعة 10 جيجابايت لكل لاعب ، والقوالب والتنبيهات القابلة للتخصيص بالكامل ، والعلامات الذكية ، و 10 مستخدمين ، وغير ذلك الكثير.",
        "loginOKQuotaReachedMain": "تخزين مجاني {percentage}٪ ممتلئ.",
        "loginOKQuotaReachedSub": "قم بالترقية إلى {plan} للحصول على سعة 10 جيجابايت لكل لاعب ، والقوالب والتنبيهات القابلة للتخصيص بالكامل ، والعلامات الذكية ، و 10 مستخدمين ، وغير ذلك الكثير.",
        "loginOKQuotaExcededMain": "تخزين مجاني كامل.",
        "loginOKQuotaExcededSub": "قم بالترقية إلى {plan} للحصول على سعة 10 جيجابايت لكل لاعب ، والقوالب والتنبيهات القابلة للتخصيص بالكامل ، والعلامات الذكية ، و 10 مستخدمين ، وغير ذلك الكثير.",
        "logoutOKStringTitle1": "لقد تم تسجيل خروجك الآن",
        "logoutOKStringDesc1": "يمكنك تسجيل الدخول مرة أخرى بالضغط على الزر أدناه.",
        "notice": "ملحوظة",
        "playerSetupString1": "إنشاء مشروعك.",
        "playerSetupString2": "إنه سهل للغاية. إنه سريع للغاية",
        "playerSetupString3": "",
        "payments": "المدفوعات",
        "pageNotFound": "عذرا، لم يتم العثور على الصفحة",
        "plan": "الخطة | الخطط",
        "popIdentifier": "معرف نقطة الاتصال",
        "postalCode": "الرمز البريدي",
        "purchasePlanUpgradeSuccessMain": "مرحبا بكم في {plan}",
        "purchasePlanDowngradeSuccessMain": "تمت ترقية الحساب إلى {planName}",
        "loggedOffInFewSeconds": "سيتم تسجيل خروجك في غضون ثوانٍ قليلة",
        "termsOfServiceString1": "شروط الخدمة",
        "termsOfServiceString2": "آخر تحديث: 9 يناير 2019",
        "termsOfServiceString3": "يرجى تنزيل وقراءة المستند التالي",
        "termsOfServiceString4": "شروط الخدمة",
        "termsOfServiceString5": "سياسة الخصوصية",
        "termsOfServiceString6": "حدد \"قبول\" للمتابعة.",
        "accept": "قبول",
        "all": "الكل",
        "allPlayers": "جميع اللاعبين",
        "add": "اصافة",
        "setPassword": "تاكيد",
        "support": "دعم",
        "cancel": "الغاء",
        "canvasSize": "حجم القماش: {size} بكسل",
        "canvasExistsError": "قماش بهذا الحجم موجود بالفعل",
        "cardType": "نوع البطاقة",
        "cardNumber": "رقم البطاقة",
        "change": "تغيير",
        "clickToEdit": "انقر للتحرير",
        "city": "المدينة",
        "color": "اللون | الألوان",
        "company": "الشركة",
        "companyName": "اسم الشركة",
        "confirm": "اكد",
        "confirmation": "تاكيد",
        "warning": "تحذير",
        "codeIsRequired": "مطلوب رمز التحقق",
        "code": "الرمز",
        "contact": "اتصال",
        "country": "البلد",
        "create": "خلق",
        "checkThePlayer": "الاتصال بالإنترنت. توصيل الطاقة.",
        "checkDetails": "التحقق من التفاصيل",
        "chooseHorizontalOrVerticalScreenOrientations": "اختر اتجاه الشاشة",
        "continue": "واصل",
        "conctactSystemAdmin": "يرجى الاتصال بمسؤول النظام الخاص بك.",
        "custom": "مخصص",
        "customerInfo": "معلومات العميل",
        "date": "التاريخ",
        "dropFilesHere": "قم بإسقاط الملفات هنا",
        "deactivate": "إلغاء التنشيط",
        "default": "اهمال",
        "delete": "مسح",
        "deleteAccount": "مسح الحساب",
        "deleteUser": "حذف المستخدم",
        "deleteOnAllPlayers": "حذف جميع اللاعبين.",
        "deleteFromSchedule": "حذف من الجدول",
        "demoVersion": "النسخة التجريبية",
        "disable": "إبطال",
        "disabled": "مبطل",
        "distributor": "موزع",
        "downgradeAccount": "تخفيض مستوى الحساب",
        "downgradeTo": "الرجوع إلى {plan}",
        "duplicate": "ينسخ",
        "duplicateFile": "ملف مكرر",
        "duplicateInSchedule": "مكرر في الجدول",
        "duration": "مدة",
        "adsDuration": "مدة الإعلانات",
        "error": "خطأ",
        "email": "البريد الالكتروني",
        "emailAlreadyExists": "يتم استخدام عنوان البريد الإلكتروني الجديد بالفعل بواسطة مستخدم آخر، يرجى استخدام عنوان مختلف.",
        "enable": "يُمكَِن",
        "enabled": "مُمَكَّن",
        "endDate": "انهاء",
        "endTime": "انهاء",
        "end": "نهاية",
        "edit": "تصحيح",
        "editProject": "تعديل المشروع",
        "feedbackForm": "تقديم ردود الفعل",
        "firstName": "الاسم الاول",
        "firmwareUpdate": "تحديث البرامج الثابتة",
        "failed": "اتصل بالدعم",
        "file": "ملف | ملفات",
        "forgotPassword": "هل نسيت كلمة السر",
        "formatNotSupported": "\"{format}\" الملفات غير مدعومة.",
        "firmware": "البرامج الثابتة",
        "freeVersion": "النسخة المجانية",
        "freeVersionNA": "النسخة المجانية غير متوفرة",
        "get": "حصل",
        "getCode": "الحصول على الاعدادات",
        "getConfig": "الحصول على الاعدادات",
        "generateNewAPIKey": "إنشاء مفتاح API جديد",
        "generateUserAPIKeyWarningMessage": "سيؤدي هذا الإجراء إلى جعل مفتاح API السابق غير صالح، وسيتعين إعادة تكوين أي اتصال موجود بواجهة API لاستخدام مفتاح API الجديد.",
        "goBack": "رجوع",
        "goToLogin": "الذهاب إلى تسجيل الدخول",
        "helpCenter": "مركز المساعدة",
        "horizontalView": "عرض أفقي",
        "image": "صورة | صور",
        "implications": "تداعيات",
        "implicationsDeleteTag": "سيؤدي هذا الإجراء إلى حذف هذه العلامة من جميع {deleteFrom}. قد يؤثر هذا على أذونات المستخدم الخاصة بك والجدول الزمني.",
        "implicationsDeleteLedTag": "سيؤدي هذا الإجراء إلى حذف هذه العلامة من جميع اللاعبين. سيتعين إعادة تكوين أي لاعب كان لديه هذه العلامة إذا كان من الممكن نشر المحتوى بهذا الدقة عليه مرة أخرى.",
        "implicationsDeletePopId": "سيؤدي هذا الإجراء إلى حذف معرف PoP هذا في كل مكان يتم استخدامه فيه.",
        "importantToNote": "من المهم أن نلاحظ",
        "logo": "الشعار",
        "userProfile": "الملف الشخصي للمستخدم",
        "userSignOut": "تسجيل الخروج",
        "userNotConfirmed": "لم يتم تأكيد المستخدم",
        "userNotFound": "المستخدم غير موجود. يرجى التأكد من أن هذا الحساب موجود",
        "userManagement": "إدارة المستخدمين",
        "id": "المعرف",
        "incorrectUsername": "بريد إلكتروني غير صحيح",
        "incorrectPassword": "كلمة المرور غير صحيحة",
        "installedOrCapacity": "عدد التركيبات / السعة",
        "installed": "تم التثبيت",
        "installedOrCapacityUnlimitedMaxValue": "عدد غير محدود من اللاعبين",
        "invalidEmail": "بريد الكتروني غير صالح",
        "invalidPassword": "كلمة المرور غير صالحة",
        "invalidUserdata": "اتصل بالدعم",
        "invalidSerialNumber": "الرقم التسلسلي غير صحيح",
        "invalidDSOSTypeAmount": "قيمة غير صالحة، الرجاء إدخال رقم.",
        "invalidResolution": "دقة غير صالحة",
        "invoice": "الفاتورة | الفواتير",
        "inviteUser": "دعوة المستخدم",
        "requiredDeviceName": "الاسم مطلوب",
        "regular": "نظامي",
        "resetPassword": "إعادة تعيين كلمة المرور",
        "loading": "تحميل...",
        "lastName": "اللقب",
        "lastLogin": "أخر تسجيل دخول",
        "modify": "تغيير",
        "monitoring": "المراقبة",
        "newPassword": "كلمة مرور جديدة",
        "newPasswordRequiredWarning": "تعيين كلمة المرور",
        "confirmNewPassword": "تأكيد كلمة المرور الجديدة",
        "new": "جديد",
        "newCanvas": "لوحة جديدة",
        "newProject": "مشروع جديد",
        "newEmail": "بريد الكتروني جديد",
        "newResolution": "دقة جديدة",
        "name": "الاسم",
        "naText": "غير متاح",
        "next": "التالي",
        "nextRenewalDate": "التجديد القادم {renewalDate}",
        "noVideoAvailable": "لا يوجد فيديو متاح.",
        "noEmailProvided": "لا يوجد بريد إلكتروني متوفر",
        "none": "لا يوجد ",
        "noSearchResults": "لا توجد نتائج",
        "noPermissionToAccessThePage": "تم رفض الوصول",
        "noPlayersInstalled": "لا يوجد مشغلات مثبتة",
        "noPlayerGroupsAvailable": "لا توجد مجموعات مشغلات متاحة",
        "notConfigured": "مطلوب الإعداد",
        "nameYourPlayerEGReception": "قم بتسمية مشغلك، على سبيل المثال الاستقبال",
        "ok": "حسنا",
        "or": "او",
        "orders": "طلبات",
        "order": "طلب | طلبات",
        "offline": "غير متصل بالانترنات",
        "online": "متصل بالانترنات",
        "options": "خيارات",
        "page": "صفحة",
        "player": "لاعب | لاعبون",
        "playerName": "اسم المشغّل",
        "playerModel": "طراز المشغّل",
        "playerGroups": "مجموعات اللاعبين",
        "pleaseEnterACity": "أدخل المدينة",
        "pin": "رقم التعريف الشخصي",
        "pinShownOnYourScreen": "رقم التعريف الشخصي (PIN) المعروض على الشاشة",
        "playTime": "وقت اللعب",
        "PleaseTryAgainOrHeadBackToTheHomepage": "يرجى المحاولة مرة أخرى أو العودة إلى الصفحة الرئيسية",
        "playerIsNotConnectedToTheCloud": "رقم تسلسلي غير صحيح",
        "pleaseTryAgain": "حاول مرة اخرى",
        "pleaseEnterThePin": "رقم التعريف الشخصي (PIN) مطلوب",
        "pleaseEnterValidPin": "أدخل رقمًا مكونًا من 4 أو 6 أرقام معروضًا على الشاشة",
        "pinMustBeFourDigitNumber": "يجب أن يكون رقم التعريف الشخصي مكونًا من 4 إلى 6 أرقام",
        "pinMustBeAtleastOneThousand": "يجب أن يكون رقم التعريف الشخصي 1000 على الأقل",
        "pleaseCheckYourEmailForVerificationCode": "سيتم إرسال رمز التحقق إلى بريدك الإلكتروني",
        "password": "كلمة المرور",
        "passwordDidNotMatch": "كلمة المرور غير متطابقة",
        "passwordCannotBeReset": "لا يمكن إعادة تعيين كلمة المرور",
        "passwordHasBeenChanged": "تم تغيير كلمة المرور الخاصة بك",
        "passwordAttemptLimitExceeded": "تم تجاوز الحد الأقصى للمحاولة، يرجى المحاولة بعد مرور بعض الوقت.",
        "passwordPolicyRequirementText": "يجب أن تكون كلمة المرور مكونة من 8 أحرف أو أكثر، مع أحرف كبيرة وصغيرة وأرقام وأحرف خاصة.",
        "price": "السعر",
        "priceSlashMonth": "السعر/الشهر",
        "priority": "الأولوية",
        "privacy": "الخصوصية",
        "project": "المشروع | المشاريع",
        "projectName": "اسم المشروع",
        "profile": "الملف الشخصي",
        "proofOfPlay": "إثبات التشغيل",
        "preview": "معاينة",
        "previewUnavailable": "المعاينة غير متوفرة",
        "proceed": "المتابعة",
        "publishTo": "النشر في",
        "releaseNotes": "ملاحظات الإصدار",
        "remove": "إزالة",
        "removeUserFromAccount": "إزالة المستخدم من الحساب",
        "replace": "استبدال",
        "reporting": "التقارير",
        "reset": "إعادة ضبط",
        "restart": "إعادة تشغيل",
        "resolution": "دقة",
        "reactivate": "إعادة تنشيط",
        "resetPasswordDescription": "أدخل البريد الإلكتروني لتلقي رمز التحقق",
        "resetPasswordCodeSent": "تم إرسال رمز التحقق إلى بريدك الإلكتروني",
        "resetPasswordCodeSentIfAccountExist": "إذا كان الحساب موجودا",
        "requiredAccountName": "اسم الحساب مطلوب",
        "requiredEmail": "البريد الالكتروني مطلوب",
        "requiredCountry": "البلد مطلوب",
        "requiredPassword": "كلمة المرور مطلوبة",
        "requiredConfirmPassword": "تأكيد كلمة المرور مطلوب",
        "requiredFirstName": "الاسم مطلوب",
        "requiredLastName": "اللقب مطلوب",
        "requiredName": "الاسم مطلوب",
        "requiredUsername": "البريد الالكتروني مطلوب",
        "requiredVerificationCode": "مطلوب رمز التحقق",
        "requiredSerialNumber": "الرقم التسلسلي مطلوب",
        "requiredCity": "المدينة مطلوبة",
        "requiredState": "الولاية مطلوبة",
        "requiredZipOrPostalCode": "الرقم البريدي مطلوب",
        "requiredStreetAndNumber": "Street and Number required",
        "requiredCompanyName": "اسم الشركة مطلوب",
        "requiredDataStorageRegion": "منطقة تخزين البيانات مطلوبة",
        "invalidDataStorageRegion": "منطقة تخزين البيانات غير صالحة",
        "review": "مراجعة",
        "signOut": "تسجيل الخروج",
        "search": "بحث",
        "addressSearchPlaceholder": "اكتب العنوان لتحديد موقع اللاعبين",
        "searching": "البحث",
        "status": "الوضع",
        "save": "حفظ",
        "reconfigure": "إعادة تشغيل الإعداد",
        "saveAs": "حفظ باسم",
        "saveChanges": "تسجيل التغيير",
        "savedStyles": "الأنماط المحفوظة",
        "schedule": "جدول",
        "scheduledToTag": "من المقرر أن يتم وضع العلامة",
        "screen": "الشاشة",
        "screenOn": "الشاشة قيد التشغيل",
        "screenOrientation": "اتجاه الشاشة",
        "security": "حماية",
        "sendCode": "إرسال الرمز",
        "sendEmail": "ارسال",
        "sendInvitation": "ارسل دعوة",
        "sendTo": "أرسل إلى",
        "serial": "الرقم التسلسلي",
        "serialNumber": "الرقم التسلسلي",
        "serialNumberAlreadyAssigned": "تم تعيين الرقم التسلسلي بالفعل",
        "select": "حدد",
        "selectAll": "حدد الكل",
        "selectLanguage": "اختر اللغة",
        "setup": "نظام",
        "settings": "اعدادات",
        "shapeColors": "ألوان الشكل",
        "shareWithText": "{productShortName} اللافتات الرقمية. بسيط. ذكي. قوي.",
        "signIn": "تسجيل الدخول",
        "signUp": "اشتراك",
        "signUpErrorMessageAccountEmailExist": "يوجد حساب بالبريد الإلكتروني المحدد بالفعل.",
        "slowSync": "مزامنة بطيئة",
        "sorry": "آسف",
        "streetAndNumber": "الشارع والرقم",
        "success": "نجاح",
        "summary": "الملخص",
        "somethingWentWrong": "لقد حدث خطأ ما",
        "song": "الأغنية | الأغاني",
        "startDate": "تاريخ البدء",
        "startTime": "بدء",
        "start": "بدء",
        "state": "الولاية",
        "steps": "الخطوات",
        "styleName": "اسم النمط",
        "storage": "التخزين",
        "subtotal": "المجموع الفرعي",
        "subscription": "الاشتراك",
        "subscriptionMonthlyAutoRenew": "شهري (تجديد تلقائي)",
        "ssoLoginErrorTitle": "حدث خطأ ما ، لا يمكننا تسجيل دخولك في الوقت الحالي ، يرجى إعادة المحاولة لاحقًا أو الاتصال بالمسؤول",
        "ssoMigrateAccountStep1Title1": "حساب {email} موجود بالفعل.",
        "ssoMigrateAccountStep1Title2": "يمكنك تبديله لاستخدام٪ {provider} SSO.",
        "ssoMigrateAccountStep1Title3": "تابع لتأكيد التبديل.",
        "ssoMigrateAccountStep2Title1": "بمجرد تأكيد التبديل إلى {provider} SSO ،",
        "ssoMigrateAccountStep2Title2": "تسجيل الدخول السابق الخاص بك لم يعد يعمل.",
        "ssoMigrateAccountStep2Title3": "لا يمكن التراجع عن هذا الإجراء.",
        "ssoMigrateAccountVerifyTitle1": "نحتاج إلى التحقق من حساب {email} الحالي الخاص بك.",
        "ssoMigrateAccountVerifyTitle2": "الرجاء تسجيل الدخول بهذا الحساب للمتابعة.",
        "tag": "العلامة | العلامات",
        "defaultTags": "العلامات الافتراضية",
        "text": "النص",
        "deleteAccountWithMultipleUsersMessage": "يجب عليك إزالة جميع المستخدمين الآخرين قبل أن تتمكن من حذف هذا الحساب.",
        "deleteAccountWithDistributorRightsMessage": "لا يمكن حذف هذا الحساب. فهو مملوك لموزع.",
        "deleteAccountTitleThisActionWill": "سيؤدي هذا الإجراء إلى",
        "deleteAccountImplications": {
            "deleteAccount": "1. حذف الحساب",
            "deleteUser": "2. حذف المستخدم"
        },
        "youCannotDeleteUserAsOnlyUserInAccount": "لا يمكنك حذف المستخدم لأنك المستخدم الوحيد في الحساب.",
        "timeZone": "المنطقة الزمنية",
        "time": "الوقت",
        "timeShorthandSecond": "ثانية",
        "timeShorthandMinute": "دقيقة",
        "timeShorthandHour": "ساعة",
        "template": "نموذج | نماذج",
        "temporaryPassword": "كلمة المرور المؤقتة",
        "tempPasswordExpiredPleaseContactAdmin": "انتهت صلاحية كلمة المرور المؤقتة. يرجى الاتصال بالمسؤول",
        "total": "المجموع",
        "tutorial": "البرنامج التعليمي | البرامج التعليمية",
        "user": "المستخدم | المستخدمون",
        "userAPIKey": "مفتاح واجهة برمجة التطبيقات",
        "userNotActive": "المستخدم غير نشط",
        "usernameShouldBeValidEmail": "يجب أن يكون اسم المستخدم بريدًا إلكترونيًا صالحًا.",
        "updatedAccountInfo": "تم تحديث معلومات حسابك.",
        "updatedCustomerInfo": "تم تحديث معلومات العميل الخاصة بك.",
        "updatedProfile": "تم تحديث ملف تعريف المستخدم الخاص بك.",
        "updated": "تم التحديث",
        "upload": "رفع",
        "upTime": "الوقت المناسب",
        "upgrade": "تحسين",
        "video": "فيديو",
        "vat": "ضريبة القيمة المضافة",
        "verificationCode": "رمز التحقق",
        "verticalView": "عرض عمودي",
        "withResolution": "{resolution} بدقة",
        "yourPlan": "الحطة الخاصة بك",
        "youHaveLeftAccount": "لقد تركت الحساب",
        "zipOrPostalCode": "مضغوط",
        "mon": "الاثنين",
        "tue": "الثلاثاء",
        "wed": "الاربعاء",
        "thu": "الخميس",
        "fri": "الجمعة",
        "sat": "السبت",
        "sun": "الاحد",
        "apps": "التطبيقات",
        "multiplePopIdsNotAllowed": "ميلافين",
        "forbidden": "حدث خطأ ما ولم نتمكن من إكمال طلبك. سيتم إعادة توجيهك إلى الصفحة الرئيسية قريبًا.",
        "dataStorageRegion": "منطقة تخزين البيانات",
        "verificationSentToEmailIfExist": "تم إرسال رمز التحقق إلى بريدك الإلكتروني (إذا كان الحساب موجودًا)",
        "alreadyHaveAnAccountRedirect": "هل لديك حساب بالفعل؟ {linkStart}تسجيل الدخول{linkEnd}",
        "emailText": "البريد الإلكتروني",
        "passwordText": "كلمة المرور",
        "signupWith": "سجّل باستخدام",
        "setNewPassword": "تعيين كلمة المرور",
        "passwordHint": "{minStart}الحد الأدنى 8 أحرف,{minEnd} {upStart}حرف كبير,{upEnd} {lowStart}حرف صغير,{lowEnd} {numStart}رقم و{numEnd} {spStart}حرف خاص{spEnd}.",
        "home": "الرئيسية",
        "loginWithName": "تسجيل الدخول باستخدام {name}",
        "signupWithName": "التسجيل باستخدام {name}",
        "fileType": "نوع الملف",
        "lastModified": "آخر تعديل",
        "images": "صور",
        "videos": "مقاطع الفيديو",
        "projectsOrPdf": "المشاريع / PDF",
        "elementiProject": "مشاريع Elementi",
        "scheduled": "مجدول",
        "notScheduled": "غير مجدول",
        "from": "من",
        "to": "إلى",
        "fileTypes": "أنواع الملفات",
        "contentStatus": "حالة المحتوى",
        "modifiedDate": "تاريخ التعديل",
        "filters": "الفلاتر",
        "sortBy": "ترتيب حسب",
        "sort": "ترتيب",
        "lastModifiedDesc": "آخر تعديل (الأحدث أولاً)",
        "lastModifiedAsc": "آخر تعديل (الأقدم أولاً)",
        "nameAsc": "الاسم (أ → ي)",
        "nameDesc": "الاسم (ي → أ)",
        "grid": "شبكة",
        "canvas": "لوحة",
        "audioPlaylist": "قائمة تشغيل صوتية",
        "isAlertActive": "هل التنبيه نشط",
        "active": "نشط",
        "inactive": "غير نشط",
        "filesPage": "صفحة الملفات",
        "ledPage": "صفحة LED",
        "videowallPage": "صفحة Videowall",
        "alertPage": "صفحة التنبيهات"
    },
    "buttons": {
        "backToProduct": "الرجوع إلى {productName}",
        "reload": "إعادة تحميل",
        "previous": "السابق",
        "next": "التالي",
        "loadMore": "تحميل المزيد",
        "addNewUser": "إضافة مستخدم جديد",
        "apply": "تطبيق",
        "clearAll": "مسح الكل",
        "reset": "إعادة تعيين",
        "tryItNow": "جرّبه الآن",
        "switchBack": "العودة للإصدار السابق",
        "cancel": "إلغاء",
        "deleteMedia": "حذف الوسائط",
        "deletePlayer": "حذف المشغل",
        "deleteTag": "حذف العلامة",
        "deletePopId": "حذف معرف PoP",
        "deleteUser": "حذف المستخدم",
        "continueWithoutSaving": "متابعة بدون حفظ",
        "close": "إغلاق",
        "cancelOrder": "إلغاء الطلب",
        "removeUser": "إزالة المستخدم",
        "deleteTemplate": "حذف القالب",
        "deleteStyle": "حذف النمط",
        "ok": "موافق",
        "delete": "حذف",
        "keepBoth": "الاحتفاظ بكليهما",
        "replaceExistingFile": "استبدال الملف الموجود",
        "replaceExistingFiles": "استبدال الملفات الموجودة"
    },
    "texts": {
        "youAreLoggingIn": "أنت تسجل الدخول باستخدام",
        "productAccessDisabled": "ليس لديك وصول إلى {product}",
        "productAccessDisabledWarning": "ليس لديك وصول إلى {product} لحساب {account}.\n\nإما أنك لم تحصل على إذن للوصول إلى هذا المنتج، أو تم إلغاء وصولك من قبل المسؤول العام. يرجى الاتصال بالمسؤول العام للحصول على مزيد من المعلومات أو لطلب الوصول.\n\nيمكنك الاستمرار في الوصول إلى المنتجات الأخرى التي لديك إذن باستخدامها ضمن هذا الحساب.",
        "tablePageCountWTotal": "عرض {min}{separator}{max} من {total}",
        "tablePageCountWoutTotal": "عرض {min}{separator}{max}",
        "dataStorageRegionHint": "اختر المنطقة التي سيتم تخزين بيانات حسابك فيها. يجب أن يتماشى هذا القرار مع قوانين حماية البيانات المحلية واحتياجات الامتثال الخاصة بك. يرجى ملاحظة: بمجرد الاختيار، لا يمكن تغيير منطقة إقامة البيانات لاحقاً.",
        "welcomeToHUB": "مرحبًا بك في SpinetiX HUB!",
        "welcomeToHUBDesc": "SpinetiX HUB هو منصتك الشاملة عبر الإنترنت لإدارة كل ما يتعلق باللافتات الرقمية SpinetiX في السحابة.",
        "hubGlobalAdmin": "مسؤول SpinetiX العام",
        "hubGlobalAdminDesc": "هذا المستخدم هو مسؤول عام في HUB، مما يمنحه تلقائياً دور المسؤول في ARYA. لا يمكن تعديل تعيين هذا الدور.",
        "removeAccessFromAryaTitle": "إزالة الوصول إلى ARYA؟",
        "removeAccessFromAryaMessage": "سيؤدي هذا إلى إزالة وصول {userName} إلى ARYA فقط.",
        "removeAccessFromAryaByNonGlobalAdmin": "لإزالة المستخدم من حساب HUB، يرجى الاتصال بـ Global Admin الخاص بك.",
        "removeAccessFromAryaByGlobalAdmin": "سيظل لديهم إمكانية الوصول إلى المنتجات الأخرى في حساب HUB هذا.\n\nلإزالة المستخدم من حساب HUB، يرجى الانتقال إلى {link}",
        "hubUserManagement": "إدارة مستخدمي HUB",
        "goToHUBUserManagement": "يرجى الانتقال إلى إدارة مستخدمي HUB.",
        "noContentHasBeenScheduledYet": "لم يتم جدولة أي محتوى بعد.",
        "emptyFilterTablePlaceholder": "لم نتمكن من العثور على أي عناصر تطابق بحثك. حاول تعديل مصطلحات البحث والمحاولة مرة أخرى!",
        "requestId": "معرّف الطلب:",
        "externalSignInMessage": "لقد سجلت الدخول باستخدام موفر هوية خارجي (مثل Google أو Facebook أو SSO مع موفر هوية آخر). يتم إدارة بيانات الاعتماد الخاصة بك، بما في ذلك {email} و {password}، من قبل هذا الموفر.",
        "youHaveUnsavedChanges": "لديك تغييرات غير محفوظة.",
        "waitForUploadingFile": "جاري رفع الملف، يرجى الانتظار...",
        "defaultTagsNote": "تورث المشاريع علامات حزمة الأنماط عند إنشائها من القالب. إذا قمت لاحقًا بإضافة علامات أو إزالتها من حزمة الأنماط، فلن يتم تحديث المشاريع الحالية.",
        "seeAll": "عرض الكل",
        "allPlayTimes": "جميع أوقات التشغيل"
    },
    "switchedAccount": {
        "title": "تم تبديل الحساب",
        "desc1": "مرحبًا بعودتك.",
        "switch": "تبديل",
        "text1": "تم تبديل الحساب",
        "text2": "إلى {account}"
    },
    "unsupportedBrowser": {
        "bannerTitle": "المتصفح الخاص بك غير مدعوم",
        "bannerMessage": "أنت تستخدم متصفحًا غير مدعوم. قد لا تعمل بعض الميزات بشكل صحيح. للحصول على أفضل تجربة مع منتجنا، يرجى التبديل إلى {highlightStart}Google Chrome{highlightEnd} أو {highlightStart}Microsoft Edge{highlightEnd}."
    },
    "plans": {
        "downgradedToFreeDesc": "تم تمكين خطة {plan} الآن. سيتم فرض رسوم على بطاقتك الائتمانية مرة أخيرة في نهاية دورة الفوترة",
        "free": "مجانا",
        "tags": "المزامنة الذكية والعلامات",
        "sharedStorage": "تخزين مشترك",
        "custom": "مخصص و تنبيهات",
        "playerStorage": "تخزين اللاعب",
        "playerPerMonth": "لاعب / شهر | لاعبون / شهر",
        "review": {
            "termsAndConditionsMain": "من خلال تقديم طلبك فإنك توافق على",
            "termsAndConditionsSub": "شروط وأحكام بيع SpinetiX"
        }
    },
    "filters": {
        "images": "صور",
        "videos": "فيديوهات",
        "audio": "صوتي",
        "projectsOrPdf": "المشاريع / PDF",
        "scheduled": "مجدول",
        "elementiProject": "مشاريع العناصر"
    },
    "template": {
        "24H": "24 ساعة",
        "AM/PM": "صباحا/مساءا",
        "addPage": "إضافة صفحة",
        "arrowSettings": "إعدادات السهم",
        "back": "رجوع",
        "background": "الخلفية",
        "both": "كلاهما",
        "bottom": "الاسفل",
        "center": "المركز",
        "cellSettings": "إعدادات الخلية",
        "clock": "الساعة",
        "clockSettings": "إعدادات الساعة",
        "countdown": " العد التنازلي",
        "countdownSettings": "إعدادات العد التنازلي",
        "custom": "مخصص",
        "changeMedia": "تغيير وسائل الإعلام",
        "default": "اهمال",
        "duplicatePage": "صفحة مكررة",
        "date": "التاريخ",
        "days": "الايام",
        "effects": "التأثيرات",
        "fade": "اخفاء",
        "fill": "ملأ",
        "front": "أمام",
        "frameFitting": "تركيب الإطار",
        "hours": "الساعات",
        "imageEffects": "تأثيرات الصورة",
        "kenBurns": "كين بيرنز",
        "noEffect": "لا يوجد تأثير",
        "noBorder": "لا حدود",
        "noMargin": "لا يوجد هامش",
        "L": "آل",
        "large": "عريض",
        "left": "اليسار",
        "local": "محلي",
        "long": "طويل",
        "M": "آم",
        "meet": "لقاء",
        "media": "وسائط الاعلام",
        "menu": "القائمة",
        "mediatable": "جدول وسائط الاعلام",
        "middle": "الوسط",
        "month": "الشهر",
        "overlay": "طبقة علوية",
        "overview": "ملخص",
        "playOnce": "العب مرة واحدة",
        "qr": "الاستجابة السريعة",
        "reg": "اعداد",
        "repeat": "تكرار",
        "right": "اليمين",
        "rss": "آر إس إس",
        "shape": "الشكل",
        "shapeSettings": "إعدادات الشكل",
        "shapeSettingsHint": "تلميح: ابدأ الكتابة لإضافة نص",
        "slice": "شريحة",
        "slide": "انزلاق",
        "small": "صغير",
        "smart": "ذكي",
        "S": "آس",
        "time": "الوقت",
        "timeAndDate": "الوقت والتاريخ",
        "tableSettings": "إعدادات الجدول",
        "text": "النص",
        "textSettings": "إعدادات النص",
        "top": "اعلى",
        "wayfinding": "إيجاد الطريق",
        "weather": "الطقس",
        "html": "صفحة على الإنترنت",
        "url": "رابط",
        "videoin": "دخل الفيديو",
        "videoWidth": "عرض الفيديو",
        "videoHeight": "ارتفاع الفيديو",
        "videoSettings": "إعدادات الفيديو",
        "frameRate": "معدل الإطارات",
        "frameWidth": "حدد العرض",
        "format": "الشكل",
        "error": {
            "invalidLink": "رابط غير صالح"
        },
        "placeholder": {
            "url": "إدخال عنوان الموقع"
        },
        "weatherIconSettings": " إعدادات رمز الطقس",
        "weatherLocationSettings": "إعدادات موقع الطقس",
        "weatherLocationSettingsHint": "تلميح: اكتب اسم الموقع",
        "webpageSettings": "إعدادات صفحة الويب",
        "qrSettings": "إعدادات QR",
        "rssSettings": "إعدادات RSS",
        "rssSettingsTooltip": "يتم الحصول على موجزات RSS التي تقدمها {productName} من <b>موفرين تابعين لجهات خارجية</b>.<br>نحن نسعى جاهدين لتوفير مجموعة متنوعة من الخلاصات لتلبية احتياجاتك؛ ومع ذلك، فإن جودتها وأدائها يعتمدان كليًا على مقدمي الخدمات التابعين لجهات خارجية.",
        "stream": "تدفق",
        "list": "قائمة"
    },
    "templates": {
        "duration": "المدة",
        "pageDuration": "مدة الصفحة",
        "timezone": "المنطقة الزمنية",
        "tags": "العلامات",
        "playtimes": "وقت اللعب",
        "alignElements": "محاذاة العناصر",
        "removeTemplateConfirmation": "هل أنت متأكد أنك تريد حذف هذا القالب من نمط \"{styleName}\"؟",
        "deleteStyleConfirmation": "هل أنت متأكد أنك تريد حذف نمط \"{styleName}\"؟",
        "deleteStyleWarning": "بحذف هذا النمط، ستزيل جميع القوالب المنشأة فيه.",
        "noTemplatesAvailable": "لا توجد قوالب متاحة",
        "noStylePackAccess": "لا تمتلك حاليًا صلاحية الوصول إلى أي حزم أنماط تحتوي على قوالب. تتوفر حزم الأنماط فقط عند مشاركتها معك من خلال الأذونات أو العلامات المخصصة لك.\nإذا كنت تعتقد أنه يجب أن يكون لديك صلاحية وصول، يرجى التواصل مع مسؤول حسابك."
    },
    "Hours": {
        "title": "العنوان",
        "time": "الساعات",
        "media": "وسائل الإعلام"
    },
    "Info": {
        "info": "معلومات",
        "title": "العنوان",
        "description": "النص",
        "media": "وسائل الإعلام"
    },
    "Logo": {
        "title": "النص"
    },
    "Menu": {
        "menu": "القائمة",
        "title": "النص",
        "price": "الثمن",
        "media": "وسائل الإعلام"
    },
    "News": {
        "news": "الاخبار",
        "title": "النص",
        "timezone": "المنطقة الزمنية",
        "format": "الشكل",
        "media": "وسائل الإعلام"
    },
    "Person": {
        "person": "شخص",
        "title": "اعلى النص",
        "description": "اسفل النص",
        "media": "وسائل الإعلام"
    },
    "Product": {
        "product": "المنتج",
        "title": "النص",
        "price": "الثمن",
        "media": "وسائل الإعلام"
    },
    "RSS": {
        "rss-news": "أخبار آر إس إس",
        "rss": "آر إس إس",
        "news": "الاخبار"
    },
    "Weather": {
        "weather": "الطقس",
        "locations": "المدينة",
        "display": "عرض",
        "media": "وسائل الإعلام"
    },
    "playerSetup": {
        "navConfirm": "تأكيد",
        "navFinish": "انهاء",
        "navNext": "التالي",
        "navPrev": "رجوع",
        "navCancel": "الغاء",
        "addPlayerToPlan": "أضف لاعبًا إلى خطتك",
        "currentPlan": "الخطة الحالية",
        "canvasName": "اسم القماش",
        "canvasVideoNote": "ستجد لوحتك الجديدة في {canvasType} تحت هذا الاسم.",
        "canvasVideoNoteType_led": "قسم ال LED",
        "canvasVideoNoteType_videowall": "قسم حائط الفيديو",
        "canvasSize": "حجم القماش",
        "canvasSizeFormatted": "{canvasSize} بكسل",
        "updateTo": "تحديث إلى",
        "numberOfPlayers": "عدد الاعبين",
        "dialogTitle": "إعداد المشغل",
        "onlyDigitsRequired": "الرجاء إدخال الأرقام فقط",
        "serialNumberRequired": "لا يمكن أن يكون الرقم التسلسلي فارغًا",
        "incorrectSerialNumber": "من فضلك أدخل الرقم التسلسلي الصحيح",
        "incorrectSerialNumberCharacters": "الرجاء إدخال إدخال صالح. يمكنك فقط استخدام الأحرف والأرقام الإنجليزية في هذا الحقل",
        "incorrectInput": "إدخال غير صحيح",
        "playerName": "الاسم",
        "playerNamePlaceholder": "اسم اللاعب",
        "requiredPlayerName": "اسم اللاعب مطلوب",
        "requiredScreenDiagonal": "مطلوب شاشة قطرية",
        "requiredHorizontalBezel": "مطلوب إطار/فجوة أفقية",
        "requiredVerticalBezel": "مطلوب إطار/فجوة عمودية",
        "playerTimezoneHint": "حدد المنطقة الزمنية للاعب",
        "Progress_PIN": "رقم التعريف الشخصي",
        "Progress_Name": "الاسم والمنطقة الزمنية",
        "Progress_DisplaySettings": "إعدادات العرض",
        "Progress_Application": "تطبيق",
        "Progress_Arrangement": "ترتيب",
        "Progress_Adjustments": "تعديلات",
        "DisplayOrientation": "اتجاه العرض",
        "DisplayResolution": "دقة العرض",
        "DisplayResolutionHint": "حدد دقة العرض",
        "Application": "تطبيق",
        "ApplicationSingleDisplay": "شاشة عرض واحدة",
        "ApplicationMirroring": "الانعكاس",
        "ApplicationVideowall": "حائط الفيديو",
        "ApplicationAvailable": "*متوفر مع",
        "ApplicationAvailbleWithNote": "*متوفر مع",
        "screenDiagonal": "شاشة قطرية",
        "SelectApplication": "حدد التطبيق",
        "SelectDisplayOrientation": "حدد اتجاه العرض",
        "SelectNumberOfDisplays": "حدد عدد العروض",
        "standardScreenOnly": "الشاشة القياسية فقط (9:16 و 16:9)",
        "OrientationAndResolution": "سيتم تطبيق إعدادات الاتجاه والدقة على جميع الشاشات",
        "DisplaysArrangement": "ترتيب العرض",
        "SelectDisplayArrangement": "حدد ترتيب العرض",
        "HorizontalBezel": "الحافة/الفجوة الأفقية",
        "VerticalBezel": "الحافة/الفجوة العمودية",
        "OutputResolutions": "دقة الإخراج",
        "CannotCreateLEDTag": "لا يمكن إنشاء دقة LED",
        "CannotCreateVideowallTag": "لا يمكن إنشاء لوحة حائط الفيديو",
        "UnknownError": "حدث خطأ غير معروف. يُرجى المحاولة مرة أخرى أو الاتصال بالدعم.",
        "InvalidAdjustmentsForm": "هناك أخطاء في التحقق من صحة الإدخال، يرجى ملء جميع الحقول بشكل صحيح",
        "CanvasDimensionsError": "لم يتم إنشاء عرض أو ارتفاع القماش بشكل صحيح",
        "playerDeleteConfirmation": "هل أنت متأكد أنك تريد حذف المشغل: {playerName}؟",
        "playerDeleteWarning": "سيؤدي حذف المشغل إلى إزالته من حسابك في SpinetiX HUB وحذف جميع الإعدادات المرتبطة به، بما في ذلك الجدولة."
    },
    "planCard": {
        "getPremium": "احصل على الافضل",
        "bestforGettingStarted": "الأفضل للبدء",
        "discovery": "اكتشاف",
        "free": "مجاني",
        "oneUser": "1 مستخدم",
        "oneGBStorage": "مساحة تخزين 1 جيجا",
        "nineTemplates": "9 قوالب",
        "yourPlan": "خطتك",
        "elevateYourDigitalSignage": "ارفع مستوى اللافتات الرقمية الخاصة بك",
        "premium": "استثنائي",
        "premiumPlanPrice": "٢١ فرنك سويسري",
        "playerPerMonth": "اللاعب / الشهر",
        "tenUsersAndRoles": "10 المستخدمين وأدوار المستخدم",
        "tenGBPlayerStorage": "10 جيجا بايت / مساحة تخزين المشغل",
        "twelveTemplatesCustomizable": "12 قوالب / قابلة للتخصيص",
        "twelveApps": "12 تطبيقًا بما في ذلك صفحة الويب",
        "elevenApps": "11 تطبيقات",
        "assetGrouping": "تجميع الأصول",
        "scheduleAutomation": "أتمتة الجدول الزمني",
        "priorityScheduling": "جدولة الأولوية",
        "alerts": "التنبيهات",
        "audio": "صوتي",
        "videoWallSupport": "* Video Wall دعم",
        "new": "جديد!",
        "withTheNew": "*مع الجديد"
    },
    "planUpgrade": {
        "errorFetchingInvoice": "حدث خطأ أثناء جلب الفاتورة. حاول مرة اخرى.",
        "close": "اغلاق",
        "getPremium": "إحصل على الأفضل!",
        "companyName": "اسم الشركة",
        "dialogTitle": "ترقية الخطة",
        "navConfirm": "تأكيد",
        "navFinish": "انهاء",
        "navNext": "التالي",
        "navPrev": "رجوع",
        "navCancel": "الغاء",
        "VATNumber": "رقم ضريبة القيمة المضافة",
        "Overview": "ملخص",
        "AccountOwner": "صاحب حساب",
        "CompanyInfo": "معلومات الشركة",
        "BillingDetails": "تفاصيل الفاتورة",
        "Payment": "دفع",
        "tryAgain": "حاول مرة ثانية",
        "paymentSuccessful": "تم الدفع بنجاح",
        "welcomeToPremium": "مرحبًا بك في Premium!",
        "paymentFailed": "عملية الدفع فشلت.",
        "selectCountry": "حدد الدولة",
        "selectState": "اختر ولايه"
    },
    "licenseOrdering": {
        "yourOrders": "طلباتك",
        "cancelOrder": "إلغاء النظام",
        "orderNumber": "رقم الأمر",
        "orderDate": "تاريخ الطلب",
        "comment1": "تعليق1",
        "comment2": "تعليق2",
        "close": "إغلاق",
        "cancelOrderWarning": "هل أنت متأكد من رغبتك في إلغاء هذا الطلب؟",
        "noOrdersAvailable": "لم تقم بتقديم أي طلبات",
        "noRecordsFound": "لم يتم العثور على نتائج للاستعلام \"{query}\"",
        "noRecordsFoundNote1": "يرجى التحقق مرة أخرى من وجود أي أخطاء مطبعية أو أخطاء في بحثك",
        "noRecordsFoundNote2": "حاول استخدام استعلام بحث مختلف"
    },
    "fileUpload": {
        "notAllowedToUploadMedia": "لا يُسمح للمستخدم بإجراء تحديث على الوسائط.",
        "hashMD5ComputationError": "حدث خطأ أثناء حساب hashMD5.",
        "duplicateFileUploadErrorTitle": "يوجد ملف بهذا الاسم بالفعل",
        "multipleDuplicateFileUploadErrorTitle": "توجد ملفات بهذه الأسماء بالفعل",
        "duplicateFileUploadErrorDescription": "يوجد ملف باسم \"{mediaName}\" بالفعل في مكتبتك.",
        "multipleDuplicateFileUploadErrorDescription": "توجد ملفات بأسماء \"{mediaNames}\" بالفعل في مكتبتك.",
        "duplicateFileUploadErrorMessage": "راجع الملف(الملفات) الموجودة واختر ما تريد فعله بالتحميل الجديد.\n{pleaseNote}: إذا استبدلت الملف الموجود، فأعد تحميل الصفحة بعد اكتمال الرفع لرؤية النسخة المحدّثة.",
        "duplicateFileUploadPreviewTitle": "الملف(الملفات) الموجود(ة)",
        "pleaseNote": "يرجى الملاحظة"
    },
    "downloadLicense": {
        "confirmDownloadLicense": "هل أنت متأكد؟ هذه الطريقة مخصصة حصريًا للمشغلات التي لن تكون متصلة بالإنترنت.",
        "confirmDownloadLicenseWarning": "استخدام هذه الطريقة سيربط الترخيص فورًا بالرقم التسلسلي دون فترة سماح للتغييرات."
    },
    "activation": {
        "assign": "تعيين",
        "yourLicenses": "التراخيص الخاصة بك",
        "comment": "تعليق",
        "playerSerialNumber": "الرقم التسلسلي للاعب",
        "licenseCode": "رمز الترخيص",
        "activationDate": "تفعيل التسجيل",
        "license": "رخصة",
        "suspend": "تعليق",
        "restore": "استعادة",
        "download": "تحميل",
        "licenseAvailable": "الترخيص متاح",
        "licenseLockedToAPlayer": "الترخيص مغلق للاعب",
        "playerSerialNumberRequired": "مطلوب رمز الرقم التسلسلي للاعب",
        "licenseCodeRequired": "رمز الترخيص مطلوب",
        "processing": "المعالجة",
        "waitingForPlayerToConnect": "في انتظار اتصال اللاعب",
        "noLicensesAvailable": "لم تقم بإضافة أي تراخيص"
    },
    "resolutionCalculator": {
        "invalidPitch": "عرض تقديمي غير صالح",
        "invalidSize": "الحجم غير صالح"
    },
    "legal": {
        "legal": "قانوني",
        "endUserLicenseAgreement": "اتفاقية ترخيص المستخدم النهائي",
        "generalTermsAndConditionsOfSale": "الشروط والأحكام العامة للبيع",
        "termsOfService": "شروط الخدمة",
        "privacyPolicy": "سياسة الخصوصية",
        "cookieNotice": "إشعار الكوكيز",
        "downloadPDF": "تنزيل ملف PDF"
    },
    "accountSuspended": {
        "bannerTitle": "انتهت صلاحية اشتراكك!",
        "bannerMessage": "إذا كنت ترغب في التجديد، يُرجى الاتصال بالموزع الذي تتعامل معه."
    },
    "errors": {
        "invalid": {
            "verificationCode": "رمز التحقق الذي تم تقديمه غير صالح، يرجى المحاولة مرة أخرى.",
            "passwordReset": "لا يمكن إعادة تعيين كلمة المرور.",
            "provider": "مزود غير صالح. يرجى المحاولة مرة أخرى.",
            "emailMismatch": "عنوان البريد الإلكتروني الذي أدخلته لا يتطابق مع الحساب الذي تحاول الانتقال إليه."
        },
        "existing": {
            "userAlreadyLinked": "المستخدم مرتبط بالفعل بموفر هوية (IdP) مختلف.",
            "accountInAnotherRegion": "لدى المستخدم حساب بالفعل في منطقة أخرى"
        },
        "failedRefreshToken": "تم تسجيل خروجك. يرجى تسجيل الدخول مرة أخرى للمتابعة.",
        "cannotMigrateAccountInAnotherRegion": "لا يمكن الانتقال إلى تسجيل الدخول الموحد (SSO) لأن عنوان بريدك الإلكتروني مرتبط بمنطقة تخزين بيانات مختلفة عن الحساب الذي تحاول الانتقال إليه.",
        "nonSSOAuthDenied": "غير مسموح بالمصادقة عبر موفر غير SSO.",
        "ssoMigrationFailed": "تم رفض الوصول: لا يمكنك التبديل إلى SSO لأن حسابك مرتبط بالفعل بمزود هوية مختلف (IdP). يرجى الاتصال بالمسؤول لمزيد من المساعدة.",
        "loginUnexpectedError": "فشل تسجيل الدخول بسبب خطأ غير متوقع. يرجى المحاولة مرة أخرى.",
        "unexpectedError": "حدث خطأ غير متوقع. يرجى إعادة تحميل الصفحة.",
        "somethingWentWrong": "يبدو أن هناك خطأً ما ({errorCode})",
        "somethingWentWrongDescription": "حدث خطأ أثناء تحميل هذه الصفحة.<br><br><strong>ما يمكنك فعله:</strong><br>أعد تحميل الصفحة وحاول مرة أخرى.<br>إذا لم تُحمَّل بعد، يرجى التواصل مع الدعم ومشاركة معرّف الطلب أدناه.",
        "failedToUpdateAccountInfo": "فشل تحديث معلومات الحساب.",
        "failedToFetchLicenses": "فشل في جلب التراخيص.",
        "failedToDownloadLicense": "فشل في تنزيل الترخيص.",
        "failedToDownloadFile": "فشل في تنزيل الملف.",
        "failedToFetchUserInfo": "فشل في جلب معلومات المستخدم",
        "failedToFetchPlaces": "فشل في جلب الأماكن",
        "fileNotSupported": "نوع الملف غير مدعوم."
    },
    "regionNames": {
        "eu": "الاتحاد الأوروبي / European Union",
        "ch": "سويسرا / Switzerland",
        "us": "الولايات المتحدة / United States",
        "ca": "كندا / Canada",
        "au": "أستراليا / Australia",
        "hk": "هونغ كونغ / Hong Kong",
        "sg": "سنغافورة / Singapore"
    },
    "zendesk": {
        "chatCouldNotBeLoaded": "لا يمكن تحميل المحادثة",
        "chatCouldNotBeLoadedDescription": "لا يمكننا تحميل محادثة الدعم. يحدث هذا عادة بسبب إعدادات الخصوصية أو ملفات تعريف الارتباط في المتصفح. للحصول على تعليمات حول كيفية تفعيل محادثة الدعم، انقر هنا: {url}."
    },
    "media": {
        "mediaUploadSuccessTitle": "جارٍ تجهيز الوسائط الخاصة بك…",
        "mediaUploadSuccessMessage": "قد لا تظهر في العرض الحالي بسبب عوامل التصفية أو الفرز النشطة.",
        "mediaViewLegacyToV2Title": "صفحات الوسائط المُعاد تصميمها",
        "mediaViewV2ToLegacyTitle": "أنت تستخدم التصميم الجديد!",
        "mediaViewSwitcherDescription": "تصفح أسرع، مع فلاتر وترتيب محسّن.",
        "mediaDeleteConfirmation": "هل أنت متأكد أنك تريد حذف \"{mediaName}\" من الوسائط؟",
        "multipleMediaDeleteConfirmation": "هل أنت متأكد أنك تريد حذف {mediaCount} من عناصر الوسائط المحددة؟",
        "mediaDeleteWarning": "سيؤدي حذف هذه الوسائط أيضًا إلى إزالتها من كل مشروع.",
        "multipleMediaDeleteWarning": "سيؤدي حذف عناصر الوسائط هذه أيضًا إلى إزالتها من كل مشروع يستخدمها.",
        "mediaFileUploadInfoMessage": "إذا لم تر الملفات في العرض الحالي، فقد تكون مخفية بسبب المرشحات النشطة أو الفرز.",
        "mediaIsReady": "وسائطك جاهزة!",
        "mediaIsReadyWithCount": "وسائطك جاهزة! ({count} من {total})",
        "someFilesUploadError": "لم يتمكن من معالجة بعض الملفات",
        "failedUploadError": "لم يتمكن من معالجة ملفاتك. حاول رفع الملفات مرة أخرى.",
        "failedUploadErrorTitle": "لم نتمكن من معالجة وسائطك"
    },
    "led": {
        "deleteCanvasConfirmation": "هل أنت متأكد؟ سيؤدي هذا الإجراء إلى حذف دقة اللوحة هذه من جميع المشغلات.",
        "deleteCanvasWarning": "أي مشغل استخدم دقة اللوحة هذه سيتطلب إعادة الإعداد قبل أن يمكن نشر محتوى بالدقة نفسها عليه مرة أخرى."
    },
    "popId": {
        "deletePopIdConfirmation": "هل أنت متأكد؟ سيؤدي هذا الإجراء إلى حذف معرف PoP هذا من كل مكان يُستخدم فيه."
    },
    "tag": {
        "deleteTagConfirmation": "هل أنت متأكد؟ سيؤدي هذا الإجراء إلى حذف هذه العلامة من جميع {source}.",
        "deleteTagWarning": "قد يؤثر هذا في أذونات المستخدم والجدول."
    },
    "leaveAccount": {
        "leaveAccountConfirmation": "هل أنت متأكد أنك تريد مغادرة الحساب [{accountName}]؟",
        "leaveAccountWarning": "بمغادرة هذا الحساب، ستفقد الوصول إلى الحساب وجميع المنتجات والخدمات المرتبطة المتاحة لك حاليًا."
    },
    "userProfile": {
        "permanent": "نهائي",
        "deleteUserConfirmation": "أنت على وشك حذف ملفك الشخصي. هذا الإجراء {permanent} ولا يمكن التراجع عنه.",
        "lose": "فقدان",
        "deleteUserWarning": "بالمتابعة، سوف {lose} الوصول إلى جميع الحسابات والمنتجات المرتبطة ببيانات اعتماد المستخدم الخاصة بك.\nهل أنت متأكد أنك تريد المتابعة?"
    }
}
